import {get, set} from 'lodash';
import {
  LOADED,
  LOGOUT,
  LOADING,
  LOGIN,
  SET_CUSTOMER
} from './UserActionsType';
import changeGACustomer from '../../app/ga/ChangeCustomer';
import {changePendoUser} from '../../app/pendo/Pendo';
import {
  GET_USERSETTINGS_SUCCESS,
  UPDATE_USERSETTINGS_SUCCESS
} from '../../UserSettings/UserSettingsActionsType';
import {SYSTEM_MEASURE} from '../../util/SystemMeasure';

const saveCurrentUser = ({customerId}) => {

  changeGACustomer(customerId);
};

export const initialState = {
  userInformation: {
    cid: null,
    customerId: null,
    changeCustomer: false,
    settings: {
      systemMeasure: SYSTEM_MEASURE.IMPERIAL
    }
  },
  authData: {},
  loading: true
};

export default function(state = initialState, action) {
  const {type} = action || {};
  switch (type) {
    case LOADED:
      changePendoUser(action.payload);
      saveCurrentUser(action.payload);
      return {...state, userInformation: action.payload, loading: false};
    case LOADING:
      return {...state, loading: true};
    case LOGIN:
      return {...state, authData: action.payload};
    case LOGOUT:
      return {...state, ...initialState};
    case SET_CUSTOMER:
      set(state, 'userInformation.cid', get(action, 'payload.cid', initialState.userInformation.cid));
      set(state, 'userInformation.customerId', get(action, 'payload.customerId', initialState.userInformation.customerId));
      return {...state};
    case GET_USERSETTINGS_SUCCESS:
      set(state, 'userInformation.settings.systemMeasure', get(action, 'payload.systemMeasure', initialState.userInformation.settings.systemMeasure));
      return {...state};
    case UPDATE_USERSETTINGS_SUCCESS:
      set(state, 'userInformation.settings.systemMeasure', get(action, 'payload.systemMeasure', initialState.userInformation.settings.systemMeasure));
      return {...state};
    default:
      return state;
  }
}
